import * as React from 'react'

const SvgMonitorIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#444CE7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.667"
      d="M6.31 17.5a8.514 8.514 0 013.69-.833c1.325 0 2.578.3 3.69.833m-8.023-3.333h8.666c1.4 0 2.1 0 2.635-.273a2.5 2.5 0 001.093-1.092c.272-.535.272-1.235.272-2.635V6.5c0-1.4 0-2.1-.272-2.635a2.5 2.5 0 00-1.093-1.093c-.534-.272-1.235-.272-2.635-.272H5.667c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 00-1.093 1.093C1.667 4.4 1.667 5.1 1.667 6.5v3.667c0 1.4 0 2.1.272 2.635a2.5 2.5 0 001.093 1.092c.535.273 1.235.273 2.635.273z"
    ></path>
  </svg>
)

export default SvgMonitorIcon
